import * as React from 'react';
import './DashboardVos.scss';
import DashboardHeader from '../../Header/DashboardHeader';
import { FC, useState } from 'react';
import SearchableDropdown, { DropdownOption } from '../../_common/SearchableDropdown/SearchableDropdown';
import { CustomButton, Error } from '../../_common';
import { useLazyQuery, useQuery } from '@apollo/client/react';
import { GetAllVosUploads, GetAllVosUploads_getAllVosUploads as VosInfo } from '../../../types/schemaTypes';
import { GET_ALL_VOS_UPLOADS } from '../../../graphql/client/queries';
import DashboardVosList from './DashboardVosList';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';

const DashboardVos: FC = (): React.ReactElement => {
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState<number | null>(currentYear);
    const [currentMonth, setCurrentMonth] = useState<number>(new Date().getMonth() + 1);
    const [selectedMonth, setSelectedMonth] = useState<number | null>(currentMonth);
    const [searchPerformed, setSearchPerformed] = useState(false);
    const canViewBillingVOS = useAuthContext().userHasPermission(PermissionEnum.ViewBillingVOS);
    const listHeight = window.screen.height;
    const generateYearsArray = (): DropdownOption[] => {
        const yearsArray: DropdownOption[] = [];
        yearsArray.push({ id: currentYear, name: `${currentYear}` });
        yearsArray.push({ id: currentYear - 1, name: `${currentYear - 1}` });
        return yearsArray;
    };

    const handleYearSelect = (year: string | null) => {
        if (year !== null) {
            const yearAsInt = parseInt(year, 10);
            setSelectedYear(yearAsInt);
        }
    };

    const generateMonthsArray = (): DropdownOption[] => {
        const months: DropdownOption[] = [];
        for (let i = 1; i <= 12; i++) {
            const monthName = new Date(2000, i - 1).toLocaleString('default', { month: 'short' });
            months.push({ id: i, name: monthName });
        }
        return months;
    };

    const handleMonthSelect = (monthName: string | null) => {
        if (monthName !== null) {
            const monthNumber = parseInt(monthName, 10);
            setSelectedMonth(monthNumber);
        }
    };

    const years = generateYearsArray();
    const months = generateMonthsArray();
    const vosInfo: VosInfo[] = [];

    document.title = 'Billing';

    const [getAllVos, { data: allVosData, loading: allVosLoading }] = useLazyQuery<GetAllVosUploads>(GET_ALL_VOS_UPLOADS);

    const handleSearch = () => {
        if (selectedYear !== null && selectedMonth !== null) {
            setSearchPerformed(true);
            vosInfo.length = 0;
            getAllVos({
                variables: {
                    input: {
                        year: selectedYear,
                        monthId: selectedMonth || 0,
                    },
                },
            });
        }
    };

    if (searchPerformed && allVosData && allVosData.getAllVosUploads && allVosData.getAllVosUploads.length !== 0) {
        allVosData.getAllVosUploads.forEach((element) => {
            if (element !== null) vosInfo.push(element as VosInfo);
        });
    }

    const { error, data, loading } = useQuery<GetAllVosUploads>(GET_ALL_VOS_UPLOADS, {
        variables: {
            input: {
                year: currentYear,
                monthId: currentMonth || 0,
            },
        },
        fetchPolicy: 'network-only',
        skip: !canViewBillingVOS
    });

    if (!searchPerformed && data && data.getAllVosUploads && data.getAllVosUploads.length !== 0) {
        data.getAllVosUploads.forEach((element) => {
            if (element !== null) vosInfo.push(element as VosInfo);
        });
    }

    if (error) {
        return <Error error={error} />;
    }

    if (!canViewBillingVOS) {
        return (
            <div className="VosProfile-Container">
                <div>
                    <div className="VosProfile-Header">
                        <div className="VosProfile-HeaderTitle">Vos Details</div>
                        <DashboardHeader />
                    </div>
                </div>

                <div className="NoResult-Container Vos-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-Second-Title-Secondary">You do not have permission to view this screen</div>
                </div>
            </div>
        )
    }

    return (
        <div className="VosProfile-Container">
            <div>
                <div className="VosProfile-Header">
                    <div className="VosProfile-HeaderTitle">Vos Details</div>
                    <DashboardHeader />
                </div>
            </div>

            <div className="Vos-Container">
                <div className="Vos-DropDown-Tab">
                    <div className="Vos-DropDown-align">
                        <SearchableDropdown
                            dropdownOptions={years}
                            id="year-selector"
                            label="YEAR"
                            value={selectedYear}
                            onSelect={(eventKey: string | null) => {
                                handleYearSelect(eventKey);
                            }}
                        />
                    </div>

                    <div className="Vos-DropDown-align">
                        <SearchableDropdown
                            dropdownOptions={months}
                            id="month-selector"
                            label="MONTH"
                            value={months.find((m) => m.id === selectedMonth)?.name ?? ''}
                            onSelect={(eventKey: string | null) => {
                                handleMonthSelect(eventKey);
                            }}
                        />

                    </div>

                    <div className="Vos-Search-Button-Container">
                        <CustomButton isBordered title="Search" onClick={handleSearch} />
                    </div>
                </div>
            </div>

            <div className="Vos-List-Header-Container">
                <div id="loadsListContainer" style={{ height: listHeight, width: '100%', overflow: 'auto' }}>
                    <div className="VosItem-Header-Container">
                        <div className="d-flex flex-column justify-content-between  col-md-2">
                            <div className="VosItem-Header-Title">Well Name</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">District</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Customer</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Mob Form</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Week 1</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Week 2</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Week 3</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Week 4</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Week 5</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">Week 6</div>
                        </div>
                        <div className="d-flex flex-column justify-content-between  col-md-1">
                            <div className="VosItem-Header-Title">De-Mob Form</div>
                        </div>
                    </div>
                    <DashboardVosList vos={vosInfo} isLoading={loading || allVosLoading} />
                </div>
            </div>
        </div>
    );
};

export default DashboardVos;
